import { ArrowRight, BarChart3, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Badge } from '../../components/common/Badge';
import { WorkspacePanel } from './PlatformWorkspace';

const MODULE_ANALYTICS = [
  {
    name: 'DiamondEdge',
    sport: 'MLB',
    status: 'Live now',
    description:
      'Open the established DiamondEdge analytics workflow with personal performance, bankroll history, and detailed market breakdowns.',
    href: '/analytics/my',
  },
  {
    name: 'GridironEdge',
    sport: 'NFL',
    status: 'Coming soon',
    description:
      'Future module analytics workspace for football-specific model calibration, market tracking, and personal performance.',
  },
  {
    name: 'CourtEdge',
    sport: 'NBA',
    status: 'Coming soon',
    description:
      'Future basketball analytics workspace for player-market attribution, confidence monitoring, and bankroll performance.',
  },
  {
    name: 'PitchEdge',
    sport: 'Soccer',
    status: 'Coming soon',
    description:
      'Future soccer analytics workspace for league-specific signal performance, recommendation drift, and validation outcomes.',
  },
];

export function ModuleAnalyticsPage() {
  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="flex items-center h-10 px-4 border-b border-surface-4 bg-surface-1 flex-shrink-0">
        <h1 className="text-xs font-semibold uppercase tracking-wider text-gray-400">Module Analytics</h1>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        <WorkspacePanel
          title="Module analytics directory"
          description="Use the platform workspace for cross-sport intelligence, keep My Analytics for your personal performance history, and jump into module workflows when you need DiamondEdge-specific detail."
        >
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
            {MODULE_ANALYTICS.map((module) => {
              const cardBody = (
                <>
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <div className="flex items-center gap-2">
                        <h3 className="text-sm font-medium text-gray-100">{module.name}</h3>
                        <Badge variant={module.href ? 'win' : 'default'} size="xs">
                          {module.status}
                        </Badge>
                      </div>
                      <div className="text-xs text-gray-500 mt-1">{module.sport}</div>
                    </div>
                    {module.href ? (
                      <BarChart3 className="w-4 h-4 text-brand flex-shrink-0" />
                    ) : (
                      <ShieldCheck className="w-4 h-4 text-gray-500 flex-shrink-0" />
                    )}
                  </div>

                  <p className="text-xs text-gray-500 leading-relaxed">{module.description}</p>

                  {module.href ? (
                    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-brand">
                      Open {module.name} analytics
                      <ArrowRight className="w-3.5 h-3.5" />
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-gray-500">
                      Module workflow will appear here when the sport launches
                    </span>
                  )}
                </>
              );

              return module.href ? (
                <Link
                  key={module.name}
                  to={module.href}
                  className="rounded-lg border border-surface-4 bg-surface-2/60 p-4 space-y-3 hover:border-brand/40 hover:bg-surface-2 transition-colors"
                >
                  {cardBody}
                </Link>
              ) : (
                <div
                  key={module.name}
                  className="rounded-lg border border-surface-4 bg-surface-2/60 p-4 space-y-3"
                >
                  {cardBody}
                </div>
              );
            })}
          </div>
        </WorkspacePanel>
      </div>
    </div>
  );
}
